module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc20",
      "id": "dd20"
    }
  }, [_c('i', [_vm._v("January 18")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "amJanuary18"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0023-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("[Christ] . . . was to come")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0023-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("J")]), _vm._v("esus . . . was made a little lower than the angels, for the suffering of death . . . that He, by the grace of God, might taste death for everyone. • One died for all. • As by one man’s disobedience many were made sinners, so also by one Man’s obedience many will be made righteous.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-05-6"
    }
  }, [_vm._v("“The first man Adam became a living being.” The last Adam became a life-giving spirit. . . . However the spiritual is not first, but the natural, and afterward the spiritual. • God said, “Let Us make man in Our image, according to Our likeness.” . . . So God created man in His own image; in the image of God He created him. • God . . . has in these last days spoken to us by His Son . . . the brightness of His glory and the express image of His person. • You have given Him authority over all flesh.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-05-7"
    }
  }, [_vm._v("The first man was of the earth, made of dust; the second Man is the Lord from heaven. As was the man of dust, so also are those who are made of dust; and as is the heavenly Man, so also are those who are heavenly.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 5:14; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 2:9; 2 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 5:14; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 5:19; 1 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 15:45–46; G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(". 1:26–27; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 1:1–3; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 17:2; 1 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 15:47–48")]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "aeJanuary18"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0023-08-11"
    }
  }, [_c('span', [_c('i', [_vm._v("The things which will take place after this")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0023-09-13"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("t is written: “Eye has not seen, nor ear heard, nor have entered into the heart of man the things which God has prepared for those who love Him.” But God has revealed them to us through His Spirit. • The Spirit of truth . . . will tell you things to come. • Behold, He is coming with clouds, and every eye will see Him, even they who pierced Him. And all the tribes of the earth will mourn because of Him. Even so, Amen.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0023-10-16"
    }
  }, [_vm._v("But I do not want you to be ignorant, brethren, concerning those who have fallen asleep, lest you sorrow as others who have no hope. For if we believe that Jesus died and rose again, even so God will bring with Him those who sleep in Jesus. . . . For the Lord Himself will descend from heaven with a shout, with the voice of an archangel, and with the trumpet of God. And the dead in Christ will rise first. Then we who are alive and remain shall be caught up together with them in the clouds to meet the Lord in the air. And thus we shall always be with the Lord.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EV")]), _vm._v(". 1:19; 1 C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OR")]), _vm._v(". 2:9–10; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 16:13; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EV")]), _vm._v(". 1:7; 1 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESS")]), _vm._v(". 4:13–14, 16–17")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b417ed74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter20.vue
// module id = 123
// module chunks = 0